var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "event-card col-md-6 col-lg-4 mb-5" }, [
    _c("a", { attrs: { href: _vm.event.url } }, [
      _c("div", { staticClass: "image-container" }, [
        _c("img", { attrs: { src: _vm.event.image, alt: _vm.event.title } }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "position-relative" }, [
      _c("p", { staticClass: "category text-uppercase text-primary" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.event.categories[0] ? _vm.event.categories[0].name : "-"
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "event-card-title" }, [
        _c("a", {
          staticClass: "text-darkgrey",
          attrs: { href: _vm.event.url },
          domProps: { innerHTML: _vm._s(_vm.event.title) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "event-date" }, [
        _c("span", { staticClass: "date-month" }, [
          _vm._v(_vm._s(_vm.event.date.month)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "date-number" }, [
          _vm._v(_vm._s(_vm.event.date.date)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "date-text" }, [
          _vm._v(_vm._s(_vm.event.date.day)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/EventCard.vue